import Vue from "vue";

const EventBus = new Vue();

// Create event bus
Object.defineProperties(Vue.prototype, {
  $syncCounts: {
    get: function () {
      return EventBus;
    },
  },
});
